import { getStateStore, isObjEmpty, isStrEmpty, getParamQueryTheme } from '@/utils/utils';
import axiosLib from 'axios';

const axiosAuth = axiosLib.create();

axiosAuth.interceptors.request.use((request) => {
    let vuexLocalStorage: any = localStorage.getItem('vuex') || '';
    vuexLocalStorage = !isStrEmpty(vuexLocalStorage) ? JSON.parse(vuexLocalStorage) : { configDevice: {} };

    const state = getStateStore();
    const token = state.token || '';
    const setting = vuexLocalStorage.configDevice;

    const code = getParamQueryTheme('code') || '';

    if (!isStrEmpty(token)) {
        request.headers.Authorization = token;
        request.headers.ContentType = 'application/json';
    }
    request.headers['lang'] = state.lang || 'fr';
    request.headers['retail-account'] = code;

    if (!isObjEmpty(setting)) {
        if (!setting.position) setting.position = {}
        setting.position.error_message = setting.location_error
        request.headers['Device-Network-Mac-Address'] = setting.mac;
        request.headers['Device-Serial-Number'] = setting.serial;
        request.headers['Device-Unique-Id'] = setting.uniqueId;
        request.headers['App-Version'] = setting.appVersion;
        request.headers['Device-Position'] = JSON.stringify(setting.position)
        // console.log(`request.headers['Device-Position']: ` + request.headers['Device-Position'])
    }

    return request;
});

axiosAuth.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data);
        }
        return Promise.reject(error.message);
    },
);

export default axiosAuth;
